// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"24a5d103","159":"c2779f95","357":"b31e04d3","396":"45ab3fbf"}[chunkId] + ".chunk.css";
};